module.exports = __webpack_public_path__ + "img/logo-ticket.e8ca1131.png";